import hasAnalyticsConsent from './hasAnalyticsConsent'

export default hasAnalyticsConsent
